import moment from 'moment'

export const getFormattedDate =(date)=> moment(date).format(
    "MMMM D, YYYY")